import { render, staticRenderFns } from "./SuperAdminCompanyModal.vue?vue&type=template&id=6edb1b69&scoped=true&"
import script from "./SuperAdminCompanyModal.vue?vue&type=script&lang=js&"
export * from "./SuperAdminCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminCompanyModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SuperAdminCompanyModal.vue?vue&type=style&index=1&id=6edb1b69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb1b69",
  null
  
)

export default component.exports